import { createAction } from '@reduxjs/toolkit'

export const setFinished = createAction('finished/setFinished')